import { Button } from 'flowbite-react';
import { Img } from 'react-image';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useThemeContext } from 'src/context/ThemeProvider';

const CreateYourProfileBanner = () => {
	const navigate = useNavigate();
	const { themeMode } = useThemeContext();
	return (
		<div className="bg-white dark:bg-[#1F2A37]">
			<div className="flex h-full w-full flex-row justify-between gap-x-4 rounded-[8px] md:max-h-[180px] max-w-[1023px] mx-auto">
				<div className="flex w-full flex-col gap-3 px-3 py-4 font-inter md:max-w-[70%]">
					<p className="bg-gradient-to-br from-teal-400 to-green-600 bg-clip-text text-[20px] font-[700] text-transparent">
						Create your LevelUp account
					</p>
					<p className="text-[14px] text-[#555770] dark:text-[#C7C9D9]">
						Log in to unlock valuable insights into your interview performance and enhance future opportunities with
						your personalized interview score.
					</p>
					<div className="flex items-center gap-3">
						<Button
							className="rounded-[8px] bg-gradient-to-br from-blue-500 to-blue-900 hover:bg-gradient-to-br hover:from-blue-600 hover:to-blue-900"
							onClick={() => navigate('/auth/register')}
						>
							Create my Profile
						</Button>
						<Button
							color={themeMode === 'light' ? 'light' : 'dark'}
							className="tex-white rounded-[8px] dark:!border-[2px] dark:!border-[#466cbe]"
							onClick={() => navigate('/auth/signin')}
						>
							Log In
						</Button>
					</div>
				</div>
				<div className="my-auto flex h-full w-full items-center justify-center sm:hidden md:max-w-[30%]">
					<Img src={'/assets/schedule.svg'} width={144} height={143} alt="interviewschedule" />
				</div>
			</div>
		</div>
	);
};

export default CreateYourProfileBanner;
